
import inputSelect from '../inputSelect'

const commonInputSelect = {
    install:function(Vue) {
        Vue.component('commonInputSelect', inputSelect)
    }
}


// 导出该组件

export default commonInputSelect